import Api from "@/lib/axios";

const AuditLogService = {
  async getAuditLogRates (payload) {
    const data = {
      ...payload,
      page: (payload.page || 1) - 1,
    };

    const response = await Api.get("/api/autopricing/history/pricing-records", {
      data: data,
      tenant: true
    });

    const list = response?.data?.content || [];
    const pagination = response?.data?.pageable || {};

    return {
      list,
      pagination: {
        ...pagination,
        totalElements: response?.data?.totalElements,
        totalPages: response?.data?.totalPages
      }
    };
  },

  async getAuditLogFees (payload) {
    const data = {
      ...payload,
      page: (payload.page || 1) - 1,
    };

    const response = await Api.get("/api/autopricing/history/fees", {
      data: data,
      tenant: true
    });

    const list = response?.data?.content || [];
    const pagination = response?.data?.pageable || {};

    return {
      list,
      pagination: {
        ...pagination,
        totalElements: response?.data?.totalElements,
        totalPages: response?.data?.totalPages
      }
    };
  },

  async getAuditLogPayoutPartnerRates (payload) {
    const data = {
      ...payload,
      page: (payload.page || 1) - 1,
    };

    const response = await Api.get("/api/autopricing/history/payout-partner-rates", {
      data: data,
      tenant: true
    });

    const list = response?.data?.content || [];
    const pagination = response?.data?.pageable || {};

    return {
      list,
      pagination: {
        ...pagination,
        totalElements: response?.data?.totalElements,
        totalPages: response?.data?.totalPages
      }
    };
  },
}

export default AuditLogService;
